import ComponentBox from './ComponentBox';
export default ComponentBox;


// WEBPACK FOOTER //
// ./src/components/ComponentBox/index.js